import domWrap from "../utils/domWrap";

export default async form => { // 'form[filters]'
	const params = location.search.split('?').join('').split('&').reduce((obj,cur) => {
			const option = cur.split('=');
			if(option[1]){
				obj[option[0].split('+').join(' ')] = decodeURIComponent(option[1].split('+').join(' '));
			}
			return obj;
		},{});
	
	domWrap(form).on('change','select',()=>form.submit());
	[...form.querySelectorAll('select')].forEach(select => (select.querySelector(`option[value="${params[select.getAttribute('name')]}"]`) || {}).selected = true);
};